module.exports = __webpack_public_path__ + "static/media/logotipo-color.92d54417.png";